import clsx from 'clsx';
import mapboxgl from 'mapbox-gl';
import { useEffect, useRef } from 'react';

import 'mapbox-gl/dist/mapbox-gl.css';
import './fixMapBox.css';
import * as styles from './Map.module.css';
import MarkerIcon from './assets/Mark.svg';

import type { LngLatLike, Map as MapType, Marker } from 'mapbox-gl';
import type React from 'react';

export type Geolocation = {
  latitude: string;
  longitude: string;
};

type Props = {
  coordinates?: Geolocation;
  className?: string;
  accessToken: string;
};

export const Map = ({ coordinates, className = '', accessToken }: Props): JSX.Element => {
  const coords: LngLatLike = [Number(coordinates?.longitude) || 0, Number(coordinates?.latitude) || 0] as [
    number,
    number,
  ];
  const map = useRef<MapType>();
  const marker = useRef<Marker>();
  const mapContainer = useRef<HTMLDivElement>();
  const markerContainer = useRef<HTMLDivElement>();
  mapboxgl.accessToken = accessToken;
  const isWebglEnabled = mapboxgl.supported() === true;

  function createMap(): void {
    if (isWebglEnabled) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current as HTMLDivElement,
        style: 'mapbox://styles/insify/ckgaprpg414yt19rxjss13h6f',
        center: coords,
        zoom: 15,
        attributionControl: false,
      });
      marker.current = new mapboxgl.Marker({ element: markerContainer.current as HTMLDivElement })
        .setLngLat(coords)
        .addTo(map.current);
    }
  }

  useEffect(() => {
    if (coordinates) {
      createMap();
    }
  }, [...coords]);

  return (
    <div
      hidden={!coordinates || !isWebglEnabled}
      ref={mapContainer as React.MutableRefObject<HTMLDivElement>}
      className={clsx(className, styles.container)}
    >
      <div ref={markerContainer as React.MutableRefObject<HTMLDivElement>}>
        <MarkerIcon />
      </div>
    </div>
  );
};
